;
//
// Javascript for the GoogleMapsControl
//
//  Josh Norris
//  Sept 2011
//
HEIJS.registerNamespace("HEIJS.Controls");
HEIJS.Controls.GoogleMap = function () {

}

HEIJS.Controls.GoogleMap.prototype = {
    id: null,
    onLoadedHandler : null,
    iframeDocument : null,
    options: null,
    iframeready: false,
    ready: false
};

HEIJS.Controls.MapManager = function () {
};


HEIJS.Controls.MapManager.prototype =
{
    maps: [],
    initialized: false,
    Initialize: function () {
		if (!this.initialized) {
			/* this avoids cross-domain scripting issues */
			if (HEIJS.context.contextHost.indexOf('.') == 0) {
				document.domain = HEIJS.context.contextHost.substring(1);
			}
			else {
				document.domain = HEIJS.context.contextHost;
			}
			this.initialized = true;
		}
    },
    /* this method is called by the iframe window's code, to register the object in the parent */
    Ready: function (identifier) {
        var iframe = $("iframe#" + identifier);
        var iframeDocument = $(iframe.contents().get(0));
        iframeDocument.ready(
            function () {
                HEIJS.page.maps._AddMap(identifier, iframeDocument);
            }
        );
    },
    /* private method used by the Ready function to register the map element with this object */
    _AddMap: function (id, iframeDocument) {
        if (!this.maps[id]) {
			this.Initialize();
            this.maps[id] = new HEIJS.Controls.GoogleMap();
            this.maps[id].id = id;
        }
        this.maps[id].iframeready = true;
        this.maps[id].iframeDocument = iframeDocument;
        this._ExecuteHandler(id);
    },
    /* public method used to register the */
    AddMap: function (id, options, onLoadedFunction) {
        if (!this.maps[id]) {
			this.Initialize();
            this.maps[id] = new HEIJS.Controls.GoogleMap();
            this.maps[id].id = id;
        }
        this.maps[id].ready = true;
        this.maps[id].options = options;
        this.maps[id].onLoadedHandler = onLoadedFunction;
        this._ExecuteHandler(id);
    },
    _ExecuteHandler: function (id) {
        if (this.maps[id].iframeready && this.maps[id].ready) {
            this.maps[id].map = new google.maps.Map(this.maps[id].iframeDocument.find("#map").get(0), this.maps[id].options);
            this.maps[id].onLoadedHandler.call($("#" + id), this.maps[id].map);
        }
    }
};

/* this is the method you use in your javascript code
   usage:

    $(document).ready(
        function() {
            var myLatlng = new google.maps.LatLng(38.97778527310839, -94.7106564044952);
            var myOptions = {
                zoom: 13,
                center: myLatlng,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            };

            $("#myMap").googleMap(myOptions, function(map) { alert(map.getZoom()); } );
        }
    );

    ALSO:

    once the onReadyFunction has been called (indicating that the Gmap has been created)
    you can access the google.maps.Map() object directly from the googleMap() function like:

    alert($(#myMap).googleMap().getZoom());


*/

$(document).ready(
    function () {
        HEIJS.page.maps = new HEIJS.Controls.MapManager();
    }
);


$.fn.googleMap = function (options, onReadyFunction) {
    if ($(this).length == 1) {
        var id = $(this).attr("id");
        if (HEIJS.page.maps.maps[id] && HEIJS.page.maps.maps[id].map) {
            return HEIJS.page.maps.maps[id].map;
        }
    }
    $(this).each(
        function () {
            var me = $(this);
            var id = $(this).attr("id");
            if (HEIJS.page.maps.maps[id]) {
                return;
            }
            HEIJS.page.maps.AddMap(id, options,
                function(map) { 
                    if (onReadyFunction) {
                        onReadyFunction.call($(this), map);
                    }
                }
            );
        }
    );
    return $(this);
};

